/* Oslo Signatur – fremdriftslinje mot fri frakt + «gavehilsen»-tekst på ordrenotatet. */
(function(){
  var cfg = window.osloFreeShipping || {};
  var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  var T = cfg.threshold ? Math.round(cfg.threshold * rate) : 0;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer = null;

  var NOTE_LABEL = cfg.en ? 'Gift message or note to us' : 'Gavehilsen eller beskjed til oss';
  var NOTE_PLACEHOLDER = cfg.en ? 'Write a greeting for the recipient, or a note to us…' : 'Skriv en hilsen til mottakeren, eller en beskjed til oss …';

  function relabelNote(){
    document.querySelectorAll('textarea[name="note"]').forEach(function(t){
      if (t.placeholder !== NOTE_PLACEHOLDER) t.placeholder = NOTE_PLACEHOLDER;
      if (t.id) {
        var l = document.querySelector('label[for="' + t.id + '"]');
        if (l && l.textContent !== NOTE_LABEL) l.textContent = NOTE_LABEL;
      }
      var details = t.closest('details');
      var s = details && details.querySelector('summary .summary__title, summary h2, summary span');
      if (s && s.textContent.trim() !== NOTE_LABEL && !s.querySelector('svg')) s.textContent = NOTE_LABEL;
    });
  }

  function fmt(c){
    var n = Math.ceil(c / 100);
    if (cfg.en) return 'NOK ' + n.toLocaleString('en-US');
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  }

  function inner(cart){
    var total = cart.total_price;
    var left = Math.max(0, T - total);
    var pct = Math.min(100, Math.round(total / T * 100));
    var msg = left > 0
      ? (cfg.en ? 'You are <strong>' + fmt(left) + '</strong> away from free shipping' : 'Du mangler <strong>' + fmt(left) + '</strong> til fri frakt')
      : (cfg.en ? '<strong>You have free shipping!</strong>' : '<strong>Du har fri frakt!</strong>');
    return '<p class="oslo-ship__text">' + msg + '</p>' +
      '<div class="oslo-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="' + (cfg.en ? 'Progress to free shipping' : 'Fremdrift mot fri frakt') + '">' +
      '<span class="oslo-ship__fill" style="width:' + pct + '%"></span></div>';
  }

  function upsert(container, before, extraClass, cart){
    if (!container) return;
    var bar = container.querySelector(':scope > .oslo-ship');
    if (!cart || cart.item_count === 0 || !T) { if (bar) bar.remove(); return; }
    var free = cart.total_price >= T;
    if (!bar) {
      bar = document.createElement('div');
      bar.setAttribute('aria-live', 'polite');
      if (before && before.parentNode === container) container.insertBefore(bar, before.nextSibling);
      else container.insertBefore(bar, container.firstChild);
    }
    bar.className = 'oslo-ship' + (extraClass ? ' ' + extraClass : '') + (free ? ' is-free' : '');
    var html = inner(cart);
    if (bar.__html !== html) { bar.innerHTML = html; bar.__html = html; }
  }

  function place(cart){
    var drawer = document.querySelector('cart-drawer .drawer__inner');
    if (drawer) upsert(drawer, drawer.querySelector('.drawer__header'), '', cart);
    var pageItems = document.querySelector('main cart-items');
    if (pageItems && pageItems.parentNode) upsert(pageItems.parentNode, null, 'oslo-ship--page', cart);
    relabelNote();
  }

  function refresh(){
    clearTimeout(timer);
    timer = setTimeout(function(){
      relabelNote();
      if (!T) return;
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(place)
        .catch(function(){});
    }, 120);
  }

  function ownMutation(m){
    if (m.target.closest && m.target.closest('.oslo-ship')) return true;
    if (m.type === 'attributes') return true;
    var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
    if (nodes.length === 0) return true;
    return nodes.every(function(n){ return (n.nodeType === 1 && n.classList.contains('oslo-ship')) || n.nodeType === 3; });
  }

  function init(){
    refresh();
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function(list){
        if (list.every(ownMutation)) return;
        refresh();
      });
      ['cart-drawer', 'main cart-items', 'main .cart__footer'].forEach(function(sel){
        var el = document.querySelector(sel);
        if (el) obs.observe(el, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();